/**
 * Created by marcfehr on 14.11.16.
 *
 * @file Contains CandidateRow class, the class responsible for showing
 * the google spreadsheet data for each candidate.
 */


import React from 'react';
import Arrow from '../googleData/imgs/arrow.svg';


import {timeParse} from 'd3-time-format';
const deChLocale = require('json!de-ch-locale');

const timestampParser = timeParse('%d/%m/%Y/%H/%M');


//region import CSS
// Semantic UI
require('ta-semantic-ui/semantic/dist/components/grid.css');
require('ta-semantic-ui/semantic/dist/components/icon.css');
require('ta-semantic-ui/semantic/dist/components/container.css');
require('ta-semantic-ui/semantic/dist/components/segment.css');
require('ta-semantic-ui/semantic/dist/components/button.css');
require('ta-semantic-ui/semantic/dist/components/image.css');
require('ta-semantic-ui/semantic/dist/components/divider.css');
require('ta-semantic-ui/semantic/dist/components/header.css');
require('ta-semantic-ui/semantic/dist/components/label.css');
//endregion

require('../googleData/css/googleData.css');

class CandidateRow extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      googleData: [],
      showDewtails: '',
      lastUpdate: '',
      lastUpdateTimestamp: ''
    };

  }

  render() {

    let wordLength = {
      function: this.props.data.Funktion.length,
      name: this.props.data.Vorname.length + this.props.data.Nachname.length
    };
    let confirmationColor = '';
    let confirmationMessage = '';
    let confirmationIcon = '';
    if (this.props.data.Confirmed == 'no') {
      confirmationColor = '#aaa';
      confirmationMessage = 'Wurde vom Senat bisher nicht bestätigt.';
      confirmationIcon = 'wait icon';
    }
    if (this.props.data.Confirmed == 'yes') {
      confirmationColor = '#54AF71';
      confirmationMessage = 'Wurde vom Senat bestätigt.';
      confirmationIcon = 'thumbs up icon';
    }
    if (this.props.data.Status == '') {
      confirmationColor = '#aaa';
      confirmationMessage = '';
      confirmationIcon = '';
    }


    return(

      <div>
        <div className={`ui top attached header ${this.props.data.Status === '' ? 'negative' : 'positive'}`}
         onClick={ () => this.setState({showDetails: !this.state.showDetails}) }
        >
          <div className='ui two column grid'>
            <div className={`left aligned column title ${this.props.data.Status === '' ? 'negative' : 'positive'}`}>
              <i className={`icon ${this.state.showDetails ? 'caret down' : 'caret right'}`}> </i>
              <span
                className={`${this.state.showDetails ? 'active' : 'inactive'} ${ wordLength.function > 23 ? 'short' : '' }`}
                style={{fontWeight: '400'}}
              >{this.props.data.Funktion}</span>
            </div>
            <div
            className={`right aligned column title ${this.props.data.Status === '' ? 'negative' : 'positive' } ${this.state.showDetails ? 'active' : 'inactive'} `}
            >
            <i className={`icon ${this.props.data.Icon} ${ parseInt(wordLength.name) > 23 ? 'short' : '' } `}
                 style={{opacity: this.props.data.Confirmed == 'no' ? '0.5' : '1'}}> </i>

              <span className='candidate name'>

                {this.props.data.Vorname} {this.props.data.Nachname}

                { this.props.data.LeavingText != '' &&
                <p
                  style={{
                    color: '#E23C4E',
                    fontWeight: 'normal'
                  }}
                >
                  {this.props.data.LeavingText}
                </p>
                }

              </span>
            </div>
          </div>
        </div>
        <div className={`ui bottom attached segment ${this.props.data.Status != '' ? 'positive' : 'negative' }`}
      style={{display: this.state.showDetails ? 'block' : 'none'}}>
          <div className='ui fluid text container vertical basic segment'>
            <p className=''><strong>{this.props.data.Titel}</strong> {this.props.data.Text}</p>
          </div>


          { this.props.data.Nachname != '' &&
            <div className='picture-wrapper' key={`picture-${this.props.dataKey}`}>
              <h4 className='ui horizontal divider header'>
                <div style={{minWidth: '130px'}}>
                  { this.props.data.Image != '' &&
                  <img className='ui medium circular image'
                       src={`http://interaktiv.tagesanzeiger.ch/2016/trump-cabinet/imgs/${this.props.data.Image}`}/>
                  }
                  { this.props.data.Image == '' &&
                  <i className='icon user' style={{display: 'none'}} />
                  }
                  <span className='no-upper-case'
                        style={{display: 'block', paddingTop: '6px'}}>{this.props.data.Vorname} {this.props.data.Nachname}</span>
                </div>
              </h4>
            </div>
          }

          { this.props.data.Status != '' &&
          <p className='confirmation-label' style={{color: confirmationColor}}><i className={ confirmationIcon }></i>{ confirmationMessage }</p>
          }

          <p style={{textAlign: 'center'}}>
            { this.props.data.Link != '' &&
            <a href={this.props.data.Link} target='_blank' className='ui primary small basic button'>
              <i className='icon external link'> </i> Zum Portrait
            </a>
            }
          </p>

        </div>
    </div>
  )
}

}

CandidateRow.propTypes = {
  data: React.PropTypes.object,
  dataKey: React.PropTypes.number
};

export default CandidateRow;



// WEBPACK FOOTER //
// ./src/components/candidateRow/CandidateRow.component.js